<template>
    <div class="modal" :id="'editUserTeamsModal' + parentId" tabindex="-1" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
                <div class="modal-header bg-white p-3">
                    <h5 class="modal-title text-grey-darkest font-medium">Edit Teams ( {{ selectedUser ? selectedUser.name : '' }} )</h5>
                    <button type="button" class="close" @click="close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group row" v-if="selectedUser">
                        <label class="col-md-4 text-grey-darkest">
                            Teams
                        </label>

                        <div class="col-md-12 flex content-center">
                            <multiselect
                                v-model="userSelectedTeams"
                                id="UserTeamList"
                                placeholder="Select Teams..."
                                :options="allTeams"
                                :multiple="true"
                                track-by="id"
                                label="name"
                                :taggable="true"
                                :close-on-select="false">
                            </multiselect>
                        </div>

                        <label class="col-md-12 mt-4 text-grey-darkest">
                            Note: Currently assigned permissions will be granted when adding a user to a new team from this window. Permissions can be uniquely customized from within the respective team after they have been added.
                        </label>
                    </div>
                </div>
                <div class="modal-footer bg-white p-2">
                    <button type="button" class="btn btn-outline-secondary mx-2" @click="close">Close</button>
                    <button type="button" class="btn btn-outline-primary mx-2" @click="updateUserTeams">Update</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
    name: "edit-user-teams-modal",
    components: {Multiselect},
    props: ['parentId'],
    data() {
        return {
            allTeams: [],
            selectedUser: null,
            selectedTeamId: null,
            userSelectedTeams: []
        }
    },
    methods: {
        open(user, teamId, allTeams) {
            this.allTeams = allTeams;
            this.selectedUser = user;
            this.selectedTeamId = teamId;
            this.userSelectedTeams = user.user_teams;
            $("#editUserTeamsModal" + this.parentId).modal("show");
        },
        close() {
            this.allTeams = [];
            this.selectedUser = null;
            this.selectedTeamId = null;
            this.userSelectedTeams = [];
            $("#editUserTeamsModal" + this.parentId).modal("hide");
        },
        updateUserTeams() {
            let self = this;

            axios.post('/settings/'+this.selectedTeamId+'/members/update/user-teams', {
                userId: self.selectedUser.id,
                teamId: self.selectedTeamId,
                teams: self.userSelectedTeams
            }).then((response) => {
                self.getToast().fire({
                    type: 'success',
                    title: 'User teams updated successfully!'
                });
                self.$emit('user-teams-updated');
                self.close();
            });
        }
    }
}
</script>

<style scoped>

</style>
